import { KeyplaneStyleValue } from "components/containers/inspectionDetail/content/inspectionDocument/components/KeyplanStyles";
import {
  ColorStyle,
  ColorType,
} from "components/containers/inspectionDetail/content/inspectionDocument/components/KeyplanStyles/config";
import { Vector3 } from ".";
import BimView from "./bimView";

export enum KeyplanOrientation {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape",
}
export const KEYPLAN_IMAGE_ROTATE_STEP = 90;

export const DEFAULT_KEYPLAN_STYLE: KeyplaneStyleValue = {
  fontSize: 11, // px
  color: ColorType.TYPE_1,
  colorStyle: ColorStyle.STATUS,
};

export interface KeyLabel {
  id: string;
  position: {
    x: number;
    y: number;
  };
  positionFromForge?: Vector3;
  rotation: number;
  navigatorLength: number;
  label: string;
  labelLength: number;
  status?: any;
  color?: string;
  colorText?: string;
}

export interface EditorDataFormText {
  defaultText: string;
  text: string;
}

export interface EditorDataImageConfig {
  rotate: number;
}

export interface EditorDataFormKeylabel extends Partial<KeyLabel> {
  updatedAt: Date;
}

export interface UpdateEditorDataFormText {
  documentKeyplanId: string;
  frameId: string;
  data: EditorDataFormText;
}

export interface UpdateEditorDataFormKeyLabel {
  documentKeyplanId: string;
  pinId: string;
  data: EditorDataFormKeylabel;
}

export interface DocumentKeyplanEditorData {
  mapFormKeylabel: {
    [pinId: string]: EditorDataFormKeylabel;
  };
  mapFormText: {
    [frameId: string]: EditorDataFormText;
  };
  imageConfig: EditorDataImageConfig;
}

export interface DocumentKeyplan {
  id?: string;
  documentId: string;
  bimViewId?: string;
  editorData?: DocumentKeyplanEditorData;
  bimViewData?: BimView;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface DocumentKeyplanDTO extends DocumentKeyplan {
  tempId?: string;
}
